import { withStyles } from '@material-ui/core';
import React from 'react';
import * as styles from './styles'
import MuiAccordion from '@material-ui/core/Accordion'
import MuiAccordionSummary from '@material-ui/core/AccordionSummary'
import MuiAccordionDetails from '@material-ui/core/AccordionDetails'
import { CollapsePlans } from './collapsePlans';

interface Props {
    result: {
        loading: boolean;
        error?: Error;
        data?: {
            inspectLog: string;
        };
    };
    group: string;
    stream: string;
    search: string;
}

export const Collapsable = ({ result, group, stream, search }: Props) => { 

    const [expanded, setExpanded] = React.useState<Array<string>>([])

    const Accordion = withStyles(styles.accordianStyles)(MuiAccordion)
    const AccordionSummary = withStyles(styles.AccordionSummaryStyles)(MuiAccordionSummary)
    const AccordionDetails = withStyles(styles.AccordionDetailStyles)(MuiAccordionDetails)
    const handleChange = (panel) => (event, newExpanded) => {
        if (expanded.indexOf(panel) > -1) {
            setExpanded(expanded.filter((a) => a != panel))
        } else {
            setExpanded([...expanded, panel])
        }
    }
    const logs = result.data?.inspectLog.split('\n') || [];
    const setupLogs = logs.filter((log) => log.includes(':setup'));
    const currentLogs = logs.filter((log) => log.includes(':current'));
    const planLogs = logs.filter((log) => log.includes(':plan'));
    const printCleanedLog = (line: string) => {
        // Remove all text before the first "-" (including the "-")
        const idx = line.indexOf('- ');
        return idx !== -1 ? line.slice(idx + 1).trim() : line;
    }

    return (
        <div style={{ border: '1px solid #eee' }}>
            <h1 style={{ width: '100%', background: 'rgba(0,0,0, 0.3)', padding: '3px' }}>
                {group} - {stream} - {search}
            </h1>
            { result.error && <div style={{ color: 'red' }}>{result.error.message}</div> }
            
            <Accordion
                square
                expanded={expanded.indexOf('setup') > -1}
                onChange={handleChange('setup')}
            >
                <AccordionSummary aria-controls="setupd-content" id="setupd-header">
                    <h2>Setup</h2>
                </AccordionSummary>
                <AccordionDetails>
                    {setupLogs.map((line, index) => (
                        <div key={index} style={{ fontSize: '13px' }}>
                            {printCleanedLog(line)}
                        </div>
                    ))}
                </AccordionDetails>
            </Accordion>
            <Accordion
                square
                expanded={expanded.indexOf('current') > -1}
                onChange={handleChange('current')}
            >
                <AccordionSummary aria-controls="currentd-content" id="currentd-header">
                    <h2>Current Bill Calculations</h2>
                </AccordionSummary>
                <AccordionDetails>
                    {currentLogs.map((line, index) => (
                        <div key={index} style={{ fontSize: '13px' }}>
                            {printCleanedLog(line)}
                        </div>
                    ))}
                </AccordionDetails>
            </Accordion>
             <Accordion
                square
                expanded={expanded.indexOf('plan') > -1}
                onChange={handleChange('plan')}
            >
                <AccordionSummary aria-controls="pland-content" id="pland-header">
                    <h2>Plan Comparison Calculations</h2>
                </AccordionSummary>
                <AccordionDetails>
                    <CollapsePlans planLogs={planLogs} />
                </AccordionDetails>
            </Accordion>
        </div>
    )
}